export const keys = {
    all: ["user-default-view"],
    list: () => [
        ...keys.all,
        "default-views"
    ]
};
